export interface ColumnDef {
    field?: string,
    header?: string,
    cell?: any,
    body?: any,
    sortable?: boolean,
    style?: any,
    expander?: any
}

export interface OrderDetailBatchUI {
  batchId: number | null;
  quantity: number;
}

export interface OrderDetailWithBatches extends OrderDetail {
  batches: OrderDetailBatchUI[];
}


export interface OrderDetail {
    orderId: number;
    orderDetailID: number;
    productID: number;
    productName: string;
    categoryName: string;
    subCategoryName: string;
    hsN_Code: string;
    orderStatusName: string;
    measurementTypeName: string;    
    unitPrice: number;
    minOrderQty: number;
    orderMultiples: number;
    quantity: number;
    pendingQuantity: number;
    taxableAmount: number;
    gst: number;
    taxAmount: number;
    grossAmount: number;
    url: string;
    trackingID: string;
    discountAmount: number;
}

export interface OrderDetailss {
    orderId: number;
    orderDetailID: number;
    productID: number;
    productName: string;
    categoryName: string;
    categoryID: number;
    subCategoryName: string;
    hsN_Code: string;
    orderStatusName: string;
    measurementTypeName: string;    
    unitPrice: number;
    minOrderQty: number;
    orderMultiples: number;
    quantity: number;
    pendingQuantity: number;
    taxableAmount: number;
    gst: number;
    taxAmount: number;
    grossAmount: number;
    url: string;
    trackingID: string;
    productId: number;
}

export interface OrderModel {
    orderStatusID: number;
    orderID: number;
    packingNo: number;
    createdDate: string;
    orderStatusName: string;
    userName: string;
    orderDate: string;
    invoicedDate: string;
    primaryContactNbr: string;
    address1: string;
    address2: string;
    landmark: string;
    zipcode: string;
    cityName: string;
    stateName: string;
    routeCodeName: string;
    gpsLocation: string;
    taxableAmount: number;
    taxAmount: number;
    discountAmount: number;
    grossAmount: number;
    handlingCharges: number;
    packingCharges: number;
    courierCharges: number;
    paymentGatewayCharges: number;
    paymentModeID: number;
    paymentModeName: string;
    gsT_Number: string;
    paymentStatus: string;
    bankRefNo: string;
    amountPaid: number;
    courierProviderName: string;
    createdUserName: string;
    createdPrimaryContactNbr: string;
    paymentRequestsOrderId: number;
    paymentStatusLogsOrderId: number;
    total_Value: number;
    invoiceNo: number;
    areaName: string;
    subDistrictName: string;
    totalAmount: number;
    districtName: string;
    countryName: string;
    orderDetail: OrderDetail[];
    orderDetails : OrderDetailss[]
    orderInvoice: OrderInvoice[];
    productID: number;
    categoryID: number;
    productName: string;
    filePath: string;
    orderStatus: string;
    paymentMode: string;
    categoryName: string;
    quantity: number;
    unitPrice: number;
    minOrderQty: number;
    orderMultiples: number;
    measurementTypeName: string;
    subCategoryName: string;
    actualPayment?: string;
    customerID :number;
    invoiceId : number;
    productId: number;
    comment: string;
}
 

export interface orderDetail1 {
    orderID: number;
    orderDate: string;
    orderStatus: string;
    orderStatusType: string;
    invoiceNo: number;
    invoiceDate: string;
    userName: string;
    mobile: string;
    address1: string;
    address2: string;
    areaName: string;
    subDistrictName: string;
    district: string;
    city: string;
    state: string;
    country: string;
    pinCode: string;
    routeCode: string;
    gpsLocation: string;
    gstNumber: string;
    mainCategory: string;
    subcategory: string;
    productName: string;
    measurementTypeName: string;
    hsnCode: string;
    unitPrice: number;
    orderQty: number;
    invoicedQuantity: number;
    pendingQuantity: number;
    totalAmount: number;
    gst: number;
    tax: number;
    grossAmount: number;
    handlingCharges: number;
    packingCharges: number;
    courierCharges: number;
    paymentGatewayCharges: number;
    invoiceamount: number;
    invoicetaxAmount: number;
    discountAmount: number;
    invoicedTotalAmount: number;
    pendingAmount: number;
    pendingTaxAmount: number;
    pendingTotalAmount: number;
    courierProvider: string;
    trackingNumber: string;
    orderPaymentType: string;
    bankRefNo: string;
    paymentStatus: string;
    actualPaymentType: string;
    orderUserName: string;
    orderedContact: string;
    invoicedUserName: string;
    invoicedContact: string;
    packingNo: number;
}
 

export interface OrderInvoices {
    orderID: number;
    invoiceNo: number;
    invoiceDate: Date;
    totalValue: number;
    handlingCharges: number;
    courierCharges: number;
    packingCharges: number;
    paymentGatewayCharges: number;
    discountAmount: number;
    grossAmount: number;
}

export interface OrderInvoceDetail {
    orderDetailID: number,
    orderID: number,
    invoiceNo: string;
    invoiceDate: Date;
    totalValue: number;
    handlingCharges: number;
    courierCharges: number;
    packingCharges: number;
    paymentGatewayCharges: number;
    discountAmount: number;
    grossAmount: number;
    productName: string;
    measurementUnit: string;
    quantity: number;
    totalAmount: number
}



export interface POSModel {
    posID: number;
    posCode: string;
    address1: string;
    address2: string;
    landmark: string;
    countryID: number;
    countryName: string;
    stateID: number;
    stateName: string;
    cityID: number;
    cityName: string;
    zipcode: string;
    gpsLocation: string | null;
    isDeleted: boolean;
    createdBy: number;
    createdDate: string;
    modifiedBy: number | null;
    modifiedDate: string | null;   
}

export interface OrderInvoice {
    invoiceNo: number,
    taxableAmount: number,
    taxAmount: number,
    discountAmount: number,
    grossAmount: number,
    paymentGatewayCharges: number,
    paymentModeID: number,
    paymentModeName: string,    
    invoicedDate: string,
    invoicedUserName: string,
    invoicedPrimaryContactNbr: string,
    orderInvoiceDetail: OrderInvoiceDetail[],
    bankRefNo: string,
    posID: string,
    orderInvoiceID: number,
    invoiceDate: string,
}

export interface OrderInvoiceDetail {
    productID: number,
    productName: string,
    unitPrice: number,
    measurementTypeCode: string,
    invoicedQuantity: number,
    totalAmount: number 
}

export interface InvoiceUserModel {
    userID: number,
    name: string
}

export interface userOption {
    userID: number;
    name: string;
    primaryContactNbr: string;
}

export interface userResult {
    userID: number;
    detail: string;
}

export interface RouteCodeModel {
    routeCodeID: number,
    name: string
}
export interface CancelledOrders{
    orderID:number,
    primaryContactNbr:string,
    userName:string,
    modifiedDate:Date,
    canceledUserName:string,
    canceledPrimaryContactNbr:string
 
}

export interface OpenOrderRow {
  UserAddressID: number;
  UserID: number;
  UserName: string;
  PrimaryContactNbr: string;
  Address1: string;
  Address2: string;
  Landmark: string;
  Zipcode: string;
  name: string;
  AreaId?: number;
  AreaName: string;
  SubDistrictName: string;
  DistrictId: number;
  DistrictName: string;
  StateID: number;
  StateName: string;
  CountryID: number;
  CountryName: string;
  IsDeleted: boolean;
  GPSLocation: string;
  RouteCodeID?: number;
  CreatedBy: string;
  OrderID: number;
   RouteCode?: string;
}


export interface MonthlyCallStatuses {
  [month: string]: string | null;
}
export interface CustomerFollowup {
  userID: number;
  customerName: string;
  primaryContactNbr: string;
  recentOrder: string;
  daysSinceRecentOrder: number;
  recentOrderAmount: number;
  routeCodeName: string | null;
  lastCalled: string | null;
  monthlyCallStatuses: MonthlyCallStatuses;
}

export interface CustomerFollowupResponse {
  followups: CustomerFollowup[];
  totalRecords: number;
  maxRecentOrderAmount:number;
  message: string;
  isSuccess: boolean;
}
 
export interface CustomerFollowupParams {
  priority: string | null;
  routeCodeName: string | null;
  currentMonth: string | null;
  showNullStatusOnly: boolean;
  salesExecutiveID:number|null;
  daysSinceRecentOrderMin: number|null;
  daysSinceRecentOrderMax:number|null;
  recentOrderAmountMin:number| null,
  recentOrderAmountMax: number|null,
  sortColumn:string;
  sortDirection:string;
  userID: number| null;
  lastCalledStartDate:string|null,
  lastCalledEndDate:string|null,
  pageNumber: number;
  pageSize: number;
}

// export interface Product {
//   productID: number;
//   productName: string;
//   unitPrice: number;
//   pendingQuantity: number;
//   gst: number;
//   orderMultiples: number;
//   minOrderQty: number;
//   productImageURL?: string;
//   orderID?: number;
//   tax: number;
//   quantity: number;
// }

// export interface OrderData {
//   orderID: number ;
//   address1?: string;
//   address2?: string;
//   areaName?: string;
//   cityName?: string;
//   countryName?: string;
//   courierCharges?: number;
//   discountAmount?: number;
//   gsT_Number?: string;
//   handlingCharges?: number;
//   invoices?: any[];
//   landmark?: string;
//   orderDate?: string;
//   orderStatusName?: string;
//   packingCharges?: number;
//   packingNo?: number;
//   paymentGatewayCharges?: number;
//   paymentMode?: string;
//   primaryContactNbr?: string;
//   products?: Product[];
//   stateName?: string;
//   subDistrictName?: string;
//   taxAmount?: number;
//   grossAmount?: number;
//   userID? : number;
//   modifiedDate? : string;
//   orderStatusID? : number;
//   taxableAmount? : number;
//   totalCost?: number;
//   userName?: string;
//   zipcode?: string;
//   amountPaid: number
// }

// export interface LastUpdateState {
//   products: Product[];
//   totalTaxable: number;
//   totalTax: number;
//   totalWeight: number;
//   disAmt: number;
// }

export enum ProductIds {
  EMPTY_BOTTLE = 142,
}
